import React from 'react';
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownTrigger,
  PageHeaderControl,
} from '@salesforce/design-system-react';
import Input from '@salesforce/design-system-react/components/input';
import InputIcon from '@salesforce/design-system-react/components/icon/input-icon';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';



export const controls = () => (
  <React.Fragment>
    <PageHeaderControl>
      <IconSettings iconPath="/assets/icons">
        <div className="slds-col_padded">
          <Input
            iconLeft={
              <InputIcon
                assistiveText={{
                  icon: 'Search',
                }}
                name="search"
                category="utility"
              />
            }
            id="search_text"
            placeholder="search text..."
          />
        </div>
      </IconSettings>
    </PageHeaderControl>
    <PageHeaderControl>
      <Dropdown
        align="right"
        id="page-header-dropdown-object-home-content-right"
        options={[
          { label: 'Menu Item One', value: 'A0' },
          { label: 'Menu Item Two', value: 'B0' },
          { label: 'Menu Item Three', value: 'C0' },
          { type: 'divider' },
          { label: 'Menu Item Four', value: 'D0' },
        ]}
      >
        <DropdownTrigger>
          <Button
            assistiveText={{ icon: 'List View Controls' }}
            iconCategory="utility"
            iconName="settings"
            iconVariant="more"
          />
        </DropdownTrigger>
      </Dropdown>
    </PageHeaderControl>
    <PageHeaderControl>
      <Dropdown
        align="right"
        assistiveText={{ icon: 'Change view' }}
        iconCategory="utility"
        iconName="settings"
        iconVariant="more"
        id="page-header-dropdown-object-home-content-right-2"
        options={[
          { label: 'Menu Item One', value: 'A0' },
          { label: 'Menu Item Two', value: 'B0' },
          { label: 'Menu Item Three', value: 'C0' },
          { type: 'divider' },
          { label: 'Menu Item Four', value: 'D0' },
        ]}
      >
        <DropdownTrigger>
          <Button
            assistiveText={{ icon: 'Change view' }}
            iconCategory="utility"
            iconName="table"
            iconVariant="more"
            variant="icon"
          />
        </DropdownTrigger>
      </Dropdown>
    </PageHeaderControl>
    <PageHeaderControl>
      <Button
        assistiveText={{ icon: 'Edit List' }}
        iconCategory="utility"
        iconName="edit"
        iconVariant="border-filled"
        variant="icon"
      />
    </PageHeaderControl>
    <PageHeaderControl>
      <Button
        assistiveText={{ icon: 'Refresh' }}
        iconCategory="utility"
        iconName="refresh"
        iconVariant="border-filled"
        variant="icon"
      />
    </PageHeaderControl>
    <PageHeaderControl>
      <ButtonGroup id="button-group-page-header-controls">
        <Button
          assistiveText={{ icon: 'Charts' }}
          iconCategory="utility"
          iconName="chart"
          iconVariant="border-filled"
          variant="icon"
        />
        <Button
          assistiveText={{ icon: 'Filters' }}
          iconCategory="utility"
          iconName="filterList"
          iconVariant="border-filled"
          variant="icon"
        />
      </ButtonGroup>
    </PageHeaderControl>
  </React.Fragment>
);
